import React from "react";
import { Dropdown } from "react-bootstrap";
import ChevronXSIcon from "../../../icons/chevron-xs.icon";
import CheckIcon from "../../../icons/check.icon";
import useDropdown from "../../../../hooks/dropdown.hook";
import styles from "../add-distributor-modal.module.scss";

export const CountryDropdown = ({ value, onChange }) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({});
  const countries = ["Spain", "France", "Portugal"];

  const handleSelect = (selectedValue) => {
    onChange(selectedValue);
    setIsOpen(false);
  };

  return (
    <Dropdown
      show={isOpen}
      onToggle={() => setIsOpen((prev) => !prev)}
      className={styles.dropdown}
    >
      <Dropdown.Toggle as="div" ref={refBtn} className={styles.dropdownToggle}>
        <div className={styles.dropdownToggleContent}>
          <span className={`${styles.dropdownToggleText} ${!value ? styles.placeholder : ""}`}>
            {value || "Select"}
          </span>
          <div className={styles.dropdownToggleIcon}>
            <ChevronXSIcon />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu ref={refMenu} className={styles.dropdownMenu}>
        {countries.map((country) => (
          <div
            key={country}
            className={`${styles.dropdownMenuItem} ${
              value === country ? styles.dropdownMenuItemWithCheck : styles.dropdownMenuItemNoCheck
            }`}
            role="option"
            aria-selected={value === country}
            tabIndex={0}
            onClick={() => handleSelect(country)}
          >
            {value === country && (
              <div className={styles.dropdownMenuItemIconContainer}>
                <CheckIcon className={styles.dropdownMenuItemIcon} fill="#616778" />
              </div>
            )}
            <div className={styles.dropdownMenuItemTextContainer}>
              <div className={styles.dropdownMenuItemLabel}>{country}</div>
            </div>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

